<template>

  <div>
    <div
      class="progress"
      :style="style"
      :class="progressClass">
      <div 
        class="progress-bar" 
        role="progressbar"
        :style="{width: deadline.percent + '%'}"
        aria-valuenow="25"
        aria-valuemin="0" 
        aria-valuemax="100">
        <span style="padding: 0 10px">{{ daysToEnd }}</span>
        </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Deadline',
  props: {
    'value': {
      type: Object,
      default: () => { return {} }
    },
    'type': {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
    deadline () {
      return this.value || {
        alert: 'secondary',
        percent: 0,
        days_to_end: null
      }
    },
    progressClass () {
      return {
        'danger': 'bg-danger',
        'success': 'bg-success',
        'warning': 'bg-warning',
        'secondary': 'bg-secondary'
      }[this.deadline.alert]
    },
    daysToEnd () {
      return this.deadline.days_to_end ? `${this.deadline.days_to_end}d` : '--'
    },
    style () {
      return {
        'default': {height: '34px'},
        'lg': {height: '33px'},
        'sm': {height: '27px'}
      }[this.type]
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .progress{
    /*background: #6c757d;*/ 
    min-width: 80px;
    max-width: 120px;
  }
    .progress.bg-secondary{
      background: rgb(108, 117, 125, 0.65) !important;
    }
    .progress.bg-danger{
      background: rgba(220, 53, 69, 0.65) !important;
    }
    .progress.bg-success{
      background: rgba(40, 167, 69, 0.65) !important;
    }
    .progress.bg-warning{
      background: rgba(255, 193, 7, 0.65) !important;
    }
  .progress.bg-secondary > .progress-bar{
    background: rgba(108, 117, 125);
  }
  .progress.bg-danger > .progress-bar{
    background: rgba(220, 53, 69, 1);
  }
  .progress.bg-success > .progress-bar{
    background: rgba(40, 167, 69, 1);
  }
  .progress.bg-warning > .progress-bar{
    background: rgba(255, 193, 7, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/Deadline.vue